import React, { useEffect } from 'react'
import AddUserForm from "../../components/Users/AddUserForm"
import UsersTable from "../../components/Users/UsersTable"

const Users = ({setHeading}) => {
  const [open, setOpen] = React.useState(false)
   const [refresh, setRefresh] = React.useState(false)
     const handleOpen = () => setOpen(true)
     const handleClose = () => setOpen(false)
     useEffect(() => {
      setHeading('Users')
     },[])
  return (
    <div>
    <AddUserForm setRefresh={setRefresh} handleOpen={handleOpen} handleClose={handleClose} open={open}/>
    <UsersTable refresh={refresh} handleOpen={handleOpen} handleClose={handleClose} open={open}/>
    </div>
  )
}

export default Users